import type { TaskExtProps } from '../../app/modules';
import { Badge } from '../../components/ui/Badge';
import { readContentExt } from './ext';

/**
 * Код матеріалу («К-12») чи паспорта послуги («НП-3») у рядку переліку й на картці дошки.
 * Нейтральний бейдж, моноширинний код (DESIGN.md «Key»). Без даних модуля — нічого.
 */
export function ContentTaskBadges({ ext }: TaskExtProps & { variant: 'row' | 'card' }) {
  const e = readContentExt(ext);
  if (!e) return null;
  const title = e.kind === 'material' ? `Матеріал ${e.code}${e.typeName ? ` · ${e.typeName}` : ''}` : `Паспорт послуги ${e.code}`;
  return (
    <Badge title={title} className="key">
      {e.code}
    </Badge>
  );
}
